export default IconNavigationEast => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-navigation-east" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M14 3h-4v6h4" />
  <path d="M10 6h2.5" />
  <path d="M16 21l-4 -8l-4 8l4 -2z" />
</svg>`;